import React from 'react';
import { CodeIcon } from 'lucide-react';
export function Hero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/vjuWEnHhKDtb58F1ELSVuz/CustomWebDevelopmentHero.png')"
  }} data-id="element-607">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-608"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-609">
        <div className="text-center" data-id="element-610">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-611">
            <CodeIcon className="w-8 h-8 text-white" data-id="element-612" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-613">
            Custom Web Application Development
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-614">
            From simple business tools to complex enterprise platforms, we build
            web applications engineered for performance, security, and
            scalability. Our full-stack development expertise covers modern
            JavaScript frameworks, robust backend systems, and cloud
            infrastructure.
          </p>
        </div>
      </div>
    </section>;
}